import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import { usePlanDropdownBaseProps } from "@Modules/eventPage/utils/plan";
import { useData, useDataRead } from "@Utils";

const KEY = "isOfferingSelectedInPlan";

export const useReadIsOfferingSelectedInPlan = ({
    urlQueryParams,
}: {
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => {
    const { value: isOfferingSelectedInPlan } = useDataRead<boolean>(KEY);
    const { hideComponent: hidePlanDropdown } = usePlanDropdownBaseProps({
        urlQueryParams,
    });
    let hideTillOfferingNotSelectedInPlan = false;
    if (!hidePlanDropdown && !isOfferingSelectedInPlan) {
        hideTillOfferingNotSelectedInPlan = true;
    }

    return {
        isOfferingSelectedInPlan,
        hideTillOfferingNotSelectedInPlan,
    };
};

export const useIsOfferingSelectedInPlan = () => {
    const {
        data: isOfferingSelectedInPlan,
        setData: setIsOfferingSelectedInPlan,
        deleteData: deleteIsOfferingSelectedInPlan,
    } = useData<boolean>(KEY, false);

    return {
        isOfferingSelectedInPlan,
        setIsOfferingSelectedInPlan,
        deleteIsOfferingSelectedInPlan,
    };
};
